import { traceBuffer } from '@/core/trace-buffer/trace-buffer'
import { loadTraces } from '@/core/trace-buffer/storage-indexeddb'

export async function getAllTraces() {
  const fromMemory = traceBuffer.getAll()

  let fromDB: any[] = []
  try {
    fromDB = await loadTraces()
  } catch (e) {
    console.warn('IndexedDB ещё не готов или ошибка:', e)
  }

  const allTraces = [...fromMemory, ...fromDB]

  const uniqueMap = new Map<string, any>()
  allTraces.forEach((t) => {
    if (!uniqueMap.has(t.id)) {
      uniqueMap.set(t.id, t)
    }
  })

  const unique = Array.from(uniqueMap.values())

  unique.sort((a, b) => a.timestamp - b.timestamp)

  const result = unique.map((t) => ({
    id: t.id,
    time: new Date(t.timestamp).toLocaleString('ru-RU'),
    persisted: !!t.persisted,
  }))

  console.log(`Всего уникальных traceId: ${result.length}`)
  console.table(result)

  return result.map(({ id, time }) => ({
    id,
    time,
  }))
}

// Делаем функцию глобальной
const setInGlobalScopeGetAllTraces = () => {
  console.log(
    '%cДля получения списка x-trace-id введи: getAllTraces()',
    'color: #00ff00; font-size: 18px; font-weight: bold; background: #000; padding: 4px 8px; border-radius: 4px;',
  )

  if (!window) return
  ;(window as any).getAllTraces = getAllTraces
}

setInGlobalScopeGetAllTraces()
